import React from 'react';
import { StyledWrapper } from './styled';

const InfoContentWrap = ({ children }) => {
    return <StyledWrapper>{children}</StyledWrapper>;
};

export default InfoContentWrap;
